import { render, staticRenderFns } from "./show_person.vue?vue&type=template&id=0139ed54"
import script from "./show_person.vue?vue&type=script&lang=js"
export * from "./show_person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports